import { formatDistanceToNow } from "date-fns";
import { Trash2 } from "lucide-react";

import Typography from "@/components/ui/typography";
import { cn } from "@/lib/utils";

import { Thread } from "../types/thread";

interface ThreadItemProps {
  thread: Thread;
  isActive: boolean;
  onClick: () => void;
  onDelete: (threadId: string) => void;
}

export const ThreadItem = ({
  thread,
  isActive,
  onClick,
  onDelete,
}: ThreadItemProps) => {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(thread.thread_id);
  };

  // Use title from backend, or fallback to "New Chat"
  const title = thread.title || "New Chat";

  return (
    <div
      className={cn(
        "flex items-center gap-2 w-full text-left px-3 py-2 rounded-md transition-all duration-200 group cursor-pointer",
        isActive ? "bg-sds-purple-20" : "hover:bg-sds-neutral-00",
      )}
      onClick={onClick}
    >
      <div className="flex-1 min-w-0 overflow-hidden max-w-full">
        <Typography
          as="div"
          size="b2"
          className={cn(
            "truncate w-full",
            isActive
              ? "text-sds-text-black font-medium"
              : "text-sds-neutral-100",
          )}
        >
          {title}
        </Typography>

        <Typography
          as="div"
          size="b3"
          className="text-sds-neutral-60 mt-0.5 truncate w-full"
        >
          {formatDistanceToNow(new Date(thread.updated_at), {
            addSuffix: true,
          })}
        </Typography>
      </div>

      <button
        onClick={handleDelete}
        className={cn(
          "p-1 rounded transition-all opacity-0 group-hover:opacity-100 flex-shrink-0",
          "hover:bg-sds-red-20 text-sds-neutral-60 hover:text-sds-red-100",
        )}
        aria-label="Delete chat"
      >
        <Trash2 className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
